import { IActivityScheduleItemBase } from '../../models/activities';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListActivityScheduleItemsProps {
  scheduleId: string;
  showInactiveItems?: boolean;
}

export type IActivityScheduleItemListItem = IActivityScheduleItemBase;

export const listActivityScheduleItemsService = async ({
  scheduleId,
  showInactiveItems,
}: IListActivityScheduleItemsProps): Promise<
  IActivityScheduleItemListItem[]
> => {
  const { data } = await jhsfBookingsApi.get<IActivityScheduleItemListItem[]>(
    `/activities/schedules/${scheduleId}/items`,
    {
      params: { showInactiveItems },
    },
  );

  return data;
};
